import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

type Props = {
  title: string
  message: string
  /** en una pagina completa reserva la altura de la cabecera fija; dentro de otra pagina, no */
  fullPage?: boolean
}

/**
 * Aviso a pantalla completa para cuando la pagina no se puede pintar (contenido
 * inexistente o error inesperado). Sustituye a la pantalla en blanco.
 */
export const ErrorState: React.FC<Props> = ({ title, message, fullPage = true }) => (
  <Wrapper fullPage={fullPage}>
    <h1>{title}</h1>
    <p>{message}</p>
    <Link to="/">Volver al inicio</Link>
  </Wrapper>
)

const Wrapper = styled.section<{ fullPage: boolean }>`
  /* la cabecera es fija: le reservamos su altura, igual que hacen los visores */
  margin-top: ${({ fullPage }) => (fullPage ? '50px' : '0')};
  padding: 60px 24px 80px;
  background-color: #fff;
  text-align: center;

  @media only screen and (min-width: 1024px) {
    margin-top: ${({ fullPage }) => (fullPage ? '100px' : '0')};
  }

  h1 {
    margin-bottom: 16px;
  }

  p {
    margin-bottom: 24px;
  }

  a {
    color: #222;
    font-family: 'Gotham-Bold';
    text-decoration: underline;
  }

  a:hover,
  a:focus {
    text-decoration: none;
  }
`
